import { state, mutations } from './mutations';
import * as getters from './getter';

export default {
  name: 'ner',
  state,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/modules/NER/_store/index.js